import * as axios from '@/axios/index'

const state = {
  tabBar: 22,
  offLine: true,
  // isReview: process.env.VUE_APP_ENV === 'review',
  isReview: false,//审核环境
  routesHistory: [], // 页面记录栈
  routerReplace: false, // 当前页面是否是replace跳转
  isPlayingVoice: null, // 當前有語音正在播放
  rankingReload: false,
  lastRankingUuid: '',
  onlyVoiceText: '搶單請錄製語音', // 僅限語音搶單的固定顯示文案
  commentGiftInfo: null, // 評論後推薦送禮的禮物信息
  avatarBorder: null,
  avatarLevel: {},
  requestError: false, //是否接口請求錯誤
  aliasList: null, //uuid别名列表
  newUserCouponPrice: 0 // 新人优惠券价格
}

const mutations = {
  SET_TAB_HEIGHT: (state, height) => {
    state.tabBar = height
  },
  SET_REQUESTERROR: (state, status) => {
    state.requestError = status
  },
  SET_OFFLINE: (state, status) => {
    state.offLine = status
  },
  SET_RANKING_RELOAD: (state, status) => {
    state.rankingReload = status
  },
  SET_PLAYING_VOICE: (state, payload) => {
    state.isPlayingVoice = payload
  },
  SET_LAST_RANKING_UUID: (state, uuid) => {
    state.lastRankingUuid = uuid
  },
  UPDATE_ROUTER_REPLACE: (state, payload) => {
    state.routerReplace = payload
  },
  UPDATE_ROUTES_HISTORY: (state, payload) => {
    state.routesHistory = payload
  },
  SET_COMMENT_GIFT_INFO: (state, payload) => {
    state.commentGiftInfo = payload
  },
  SET_AVATAR_BORDER: (state, payload) => {
    state.avatarBorder = payload
  },
  SET_AVATAR_LEVEL: (state, payload) => {
    state.avatarLevel = payload
  },
  SET_UUID_ALIAS_LIST: (state, payload) => {
    state.aliasList = payload
  },
  SET_NEW_USER_COUPON_PRICE: (state, price) => {
    state.newUserCouponPrice = price || 0
  },
}
let giftPromise
const actions = {
  setLastRankingUuid({
    commit
  }, uuid) {
    commit('SET_LAST_RANKING_UUID', uuid)
  },
  getCommentGiftInfo({
    commit,
    state
  }) {
    if (state.commentGiftInfo) return Promise.resolve(state.commentGiftInfo)
    if (giftPromise) {
      return giftPromise.promise
    } else {
      giftPromise = {}
      giftPromise.promise = new Promise((resolve, reject) => {
        giftPromise.resolve = resolve
        giftPromise.reject = reject
      })
      axios.get('/gift/afterOrder', {})
        .then(({
          data
        }) => {
          commit('SET_COMMENT_GIFT_INFO', data)
          giftPromise.resolve(data)
        })
      return giftPromise.promise
    }
  },
  setRequestError({
    commit
  }, status) {
    commit('SET_REQUESTERROR', status)
  },
  setOffline({
    commit
  }, status) {
    if(status) {
      // navigator.onLine不一定准确，加多一次网络请求来判断
      axios.post('/basic/front/error', {
        message: '测试网络是否已断开',
      }).then(()=>{
        commit('SET_OFFLINE', !status)
      }).catch(()=>{
        commit('SET_OFFLINE', status)
      })
    } else {
      commit('SET_OFFLINE', status)
    }
  },
  setTabHeight({
    commit
  }, tabBar) {
    commit('SET_TAB_HEIGHT', tabBar)
  },
  toggleVoicePlay({
    commit
  }, payload) {
    commit('SET_PLAYING_VOICE', payload)
  },
  setRankingReload({
    commit
  }, status) {
    commit('SET_RANKING_RELOAD', status)
  },
  updateRoutesHistory({
    commit
  }, payload) {
    commit('UPDATE_ROUTES_HISTORY', payload)
  },
  getAvatarBorder: ({ commit }) => {
    return new Promise((resolve, reject) => {
      axios.get('/basic/config')
        .then(({
          data
        }) => {
          commit('SET_AVATAR_BORDER', data.giftLabelImage)
          commit('SET_AVATAR_LEVEL', data.userLevelImage)
          commit('SET_NEW_USER_COUPON_PRICE', data.newUserCouponPrice)
          resolve(data)
        })
        .catch((e) => {
          reject(e)
        })
    })
  },
  setAliasList({ commit }) {
    axios.get('/user/getAllAlias').then(({ data }) => {
      commit('SET_UUID_ALIAS_LIST', data);
    })
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
